import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const Container = styled.div`
  height: 100%;
  width: 100%;
  background-color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`

const Message = styled.p`
  color: white;
  text-align: center;
  font-size: 16px;
`

const Expired = () => {
  const { t } = useTranslation()
  return (
    <Container>
      <Message>{t('secureAccess.expired')}</Message>
    </Container>
  )
}

export default Expired
